import { render, staticRenderFns } from "./TargetMarketIcon.vue?vue&type=template&id=6e32b0f3&scoped=true"
import script from "./TargetMarketIcon.vue?vue&type=script&lang=js"
export * from "./TargetMarketIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e32b0f3",
  null
  
)

export default component.exports